<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default{
    name:"table-evaluasi-sikap-perilaku",

    data(){

        return{
        id: this.$route.params.id,
        templateExcel: '/template_excel/template_sikap_perilaku.xlsx',
        showModal : false,
        pathExcel:false,
        nilaiSikapPerilaku: null,
        loadingTable:true,

        dataTableSikapPerilaku: [],
        }
    },
    mounted(){
        this.getDataTableEvaluasiSikapPerilaku(this.id);
    },
    methods:{
    getDataTableEvaluasiSikapPerilaku(id) {
      let self = this;
      self.loadingTable = true;

      // get data table evaluasi stula
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/evaluasi-sikap-perilaku",
        params: {
          id: id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config)
        .then(function (response) {
          self.loadingTable = false;

          var response_data = response.data;
          var response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            self.dataTableSikapPerilaku = response_data_fix;
          } else {
            self.dataTableSikapPerilaku = [];
          }
        })
        .catch(function (error) {
          self.loadingTable = false;
          self.dataTableSikapPerilaku = [];
          console.log(error);
        });
    },
    mathSikapPerilaku(row_data) {
      const aspeksi1 = parseFloat(row_data.aspeksi1) || 0;
      const aspeksi2 = parseFloat(row_data.aspeksi2) || 0;
      const aspeksi3 = parseFloat(row_data.aspeksi3) || 0;
      const aspeksi4 = parseFloat(row_data.aspeksi4) || 0;
      const aspeksi5 = parseFloat(row_data.aspeksi5) || 0;
      const aspeksi6 = parseFloat(row_data.aspeksi6) || 0;

      row_data.nilaiSikapPerilaku = ((aspeksi1 * 0.03) + (aspeksi2 * 0.02) + (aspeksi3 * 0.03) + (aspeksi4 * 0.02) + (aspeksi5 * 0.02) + (aspeksi6 * 0.03)) * 0.08;
      row_data.nilaiSikapPerilaku = row_data.nilaiSikapPerilaku.toFixed(2);
    },
    importEvaluasiSikapPerilaku() {
      let self = this;
      self.showModal = true;
    },
    inputFileExcelSikapPerilaku() {
      let self = this;
      if ($("#inputExcelEvaluasiSikapPerilaku")[0].files[0]) {

        let fileName = $("#inputExcelEvaluasiSikapPerilaku")[0].files[0].name;
        let fileExtension = fileName.split('.').pop().toLowerCase();

        if (fileExtension === 'xlsx') {
          $("#uploadLoadingSikapPerilaku").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#inputExcelEvaluasiSikapPerilaku")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            var resStatus = response.status;
            if (resStatus === 200) {
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingSikapPerilaku").html(
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-check"></i>' +
                'Berhasil' +
                '</span>' +
                '<a href="' + urlres + '" target="_blank" style="padding-left:10px;">' +
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-eye"></i>' +
                'Lihat File' +
                '</span>' +
                '</a>'
              );

              self.pathExcel = path_file;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong !',
                showConfirmButton: true,
              });
            }
          });
        } else {
          alert("Format file harus ber-type (XLSX)");
          $('#inputExcelEvaluasiSikapPerilaku').val('');
        }
      }
    },
    exportEvaluasiSikapPerilaku() {
      let self = this;

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/eksportEvaluasi/sikap-perilaku',
        params: {
          id: self.id,
        },
        crossdomain: true,
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        withCredentials: true,
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.close();
          // Download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Evaluasi Nilai Sikap Perilaku.xlsx'); // Update filename if needed
          document.body.appendChild(link);
          link.click();
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n' + error,
          showConfirmButton: true
        });
      });
    },
    storeImportEvaluasiSikapPerilaku() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/importEvaluasi/sikapPerilaku",
        data: {
          id: self.id,
          path_excel: self.pathExcel
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Success upload data !',
            showConfirmButton: true,
          });

          $("#inputExcelEvaluasiSikapPerilaku").val('');
          $("#uploadLoadingSikapPerilaku").empty();
          self.showModal = false;

          self.getDataTableEvaluasiSikapPerilaku(self.id);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong !',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n ' + error,
          showConfirmButton: true,
        });
      });
    },
    }
}
</script>
<template>
    <div class="row mt-3 mb-2">
        <div class="col-12">
        <div class="card-title">Evaluasi Sikap Perilaku</div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12 text-end">
        <b-button variant="info" size="sm" @click="importEvaluasiSikapPerilaku()">
            <i class="fas fa-upload"></i>
            &nbsp;
            <b>Import Evaluasi Sikap Perilaku</b>
        </b-button>
        &nbsp;
        <b-button variant="info" size="sm" @click="exportEvaluasiSikapPerilaku()">
            <i class="fas fa-file-excel"></i>
            &nbsp;
            <b>Export Evaluasi Sikap Perilaku</b>
        </b-button>
        </div>
    </div>


    <div class="col-12">
        <div class="table-responsive pb-3">
        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
            <thead class="redTheme align-middle">
            <tr>
                <th class="text-center" rowspan="4">NDH</th>
                <th class="text-center" rowspan="4">Nama Peserta</th>
                <th class="text-center" rowspan="4">Instasi</th>
                <th class="text-center" colspan="12">Aspek</th>
                <th class="text-center" rowspan="4">Total</th>
            </tr>
            <tr>
                <th class="text-center" colspan="2">Kerja Sama dan Prakarsa (3%)</th>
                <th class="text-center" colspan="2">Kerja Sama, Kedisiplinan Kepemimpinan (2%)</th>
                <th class="text-center" colspan="2">Kepemimpinan (3%)</th>
                <th class="text-center" colspan="2">Kedisiplinan (2%)</th>
                <th class="text-center" colspan="2">Kedisiplinan (2%)</th>
                <th class="text-center" colspan="2">Pengembangan Potensi Diri (3%)</th>

            </tr>
            <tr>
                <th class="text-center" colspan="2">Penilaian Atas inisiatif Kerja Sama dan Keaktifan</th>
                <th class="text-center" colspan="2">Penilaian Dilakukan Melalui Sosiometri Pada</th>
                <th class="text-center" colspan="2">Penilaian Atas Peran Peserta Dalam</th>
                <th class="text-center" colspan="2">Penilaian Atas Kehadiran</th>
                <th class="text-center" colspan="2">Penilaian Atas Kepatuhan Kode Etik</th>
                <th class="text-center" colspan="2">Penilaian Atas Rencana dan </th>
            </tr>
            <tr>
                <th class="text-center" style="min-width: 100px;">Nilai</th>
                <th class="text-center">3%</th>
                <th class="text-center" style="min-width: 100px;">Nilai</th>
                <th class="text-center">2%</th>
                <th class="text-center" style="min-width: 100px;">Nilai </th>
                <th class="text-center">3%</th>
                <th class="text-center" style="min-width: 100px;">Nilai</th>
                <th class="text-center">2%</th>
                <th class="text-center" style="min-width: 100px;">Nilai</th>
                <th class="text-center">2%</th>
                <th class="text-center" style="min-width: 100px;">Nilai</th>
                <th class="text-center">3%</th>
            </tr>
            </thead>
            <tbody class="align-top">
            <tr v-if="loadingTable == true">
                <td colspan="30">
                <i class="fas fa-spin fa-spinner"></i>
                &nbsp;
                <span>loading . . .</span>
                </td>
            </tr>
            <tr v-else-if="dataTableSikapPerilaku == ''">
                <td colspan="30" class="text-center">
                -- Data Kosong --
                </td>
            </tr>
            <tr v-else v-for="(row_data3, key_data3) in dataTableSikapPerilaku" :key="key_data3">
                <td class="text-center">{{ key_data3 + 1 }}</td>
                <td>{{ row_data3.user.name }}</td>
                <td class="text-center">Smartsoft</td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi1 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi1 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi2 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi2 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi3 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi3 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi4 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi4 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi5 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi5 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.aspeksi6 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.percent_aspeksi6 }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data3.user.name">
                    {{ row_data3.nilai_sikap_perilaku }}
                </span>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>

      <b-modal v-model="showModal" title="Import Evaluasi Sikap Perilaku" title-class="text-black font-18" body-class="p-3" hide-footer>
    <form @submit.prevent="storeImportEvaluasiSikapPerilaku()">
      <div class="row mt-2">
        <div class="col-12 text-end">
          <a :href="templateExcel" target="_blank" class="btn btn-sm btn-success" style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
            <i class="fas fa-download"></i>
            &nbsp;
            <span><b>Download Template</b></span>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input type="file" class="form-control" id="inputExcelEvaluasiSikapPerilaku" placeholder="Masukkan File Excel . . ." v-on:change="inputFileExcelSikapPerilaku()" accept=".xlsx" style="border-top-right-radius: 0px !important;">
        </div>
        <div class="col-12">
          <div class="respond-input-file float-left" id="uploadLoadingSikapPerilaku"></div>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <b-button variant="primary" type="submit">
            <i class="fas fa-check"></i>
            &nbsp;
            <span><b>Simpan</b></span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>
</template>

